// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Toasts_wrapper__2BXgs"};